import { useState } from 'react';
import { BlogWritingForm } from '@/components/blog/BlogWritingForm';
import type { BlogWritingFormValues } from '@/components/blog/BlogWritingForm';

export const KeywordAnalysisPage = () => {
  const [isGenerating, setIsGenerating] = useState(false);
  const [generatedContent, setGeneratedContent] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = async (values: BlogWritingFormValues) => {
    setIsGenerating(true);
    setErrorMessage('');

    try {
      // TODO: API 연동 - 블로그 콘텐츠 생성 요청
      // const response = await fetch('/api/blog/generate', {
      //   method: 'POST',
      //   headers: { 'Content-Type': 'application/json' },
      //   body: JSON.stringify(values),
      // });

      // 임시 시뮬레이션
      await new Promise(resolve => setTimeout(resolve, 2000));

      setGeneratedContent(`# ${values.title}\n\n키워드: ${values.keyword}\n\n콘텐츠가 생성되었습니다.`);
    } catch (error) {
      setErrorMessage('글 작성 중 오류가 발생했습니다.');
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <main className="page">
      <header className="page__header">
        <div>
          <h1>✍️ 블로그 글 작성기</h1>
          <p>AI를 활용하여 고품질 블로그 콘텐츠를 자동으로 생성합니다.</p>
        </div>
      </header>

      <section className="page__section">
        <BlogWritingForm onSubmit={handleSubmit} isLoading={isGenerating} />
      </section>

      {errorMessage && (
        <section className="page__section">
          <div className="error-message" style={{
            padding: '16px',
            background: '#fee',
            color: '#c33',
            borderRadius: '8px',
            border: '1px solid #fcc'
          }}>
            {errorMessage}
          </div>
        </section>
      )}

      {generatedContent && (
        <section className="page__section">
          <div className="generated-content" style={{
            padding: '20px',
            background: 'white',
            borderRadius: '12px',
            border: '1px solid #e5e7eb',
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
          }}>
            <h3 style={{ marginTop: 0, marginBottom: '16px', color: '#111827' }}>생성된 콘텐츠</h3>
            <div style={{
              whiteSpace: 'pre-wrap',
              lineHeight: '1.6',
              color: '#374151'
            }}>
              {generatedContent}
            </div>
          </div>
        </section>
      )}
    </main>
  );
};
